import ListagemCreditosHomeTemplate from '@/components/organisms/ListagemCreditosHome';
import PlanosDisponiveis from '@/components/organisms/PlanosDisponiveis';
import React, { Fragment, lazy, Suspense } from 'react';
import { useTheme } from 'styled-components';
import { useHomeData } from '@/hooks/useHomeData';
import BeneficiosChippuDesktopFallback from '@/components/organisms/BeneficiosChippu/Designs/Desktop/fallback';
import { Skeleton } from '@/components/atoms/Skeleton';
// import MinhaCarteiraDetalhamentoFallback from '@/components/organisms/MinhaCarteiraDetalhamento/fallback';
import {
  PrimeiraSecaoHomeDesktop,
  SegundaSecaoHomeDesktop,
  UltimaSecaoHomeDesktop,
} from './styles';

const CarouselDestaques = lazy(
  () => import('@/components/organisms/CarouselDestaques'),
);
const BeneficiosChippu = lazy(
  () => import('@/components/organisms/BeneficiosChippu'),
);
const Galeria = lazy(() => import('@/components/molecules/Galeria'));

const AssinaturasRecorrentes = lazy(
  () => import('@/components/organisms/AssinaturasRecorrentes'),
);
const MinhaCarteiraDestaque = lazy(
  () => import('@/components/organisms/MinhaCarteiraDestaque'),
);

const DestaquesDaSemana = lazy(
  () => import('@/components/organisms/DestaquesDaSemana'),
);

// const MinhaCarteiraDetalhamento = lazy(
//   () => import('@/components/organisms/MinhaCarteiraDetalhamento'),
// );

export default function HomePaginaDesktop() {
  const theme = useTheme();
  const {
    destaquesDesktop,
    combos,
    bannersCarousel,
    bannersPromocionaisDesktop,
  } = useHomeData();

  return (
    <Fragment>
      <Suspense fallback={<Skeleton style={{ height: 560 }} />}>
        <CarouselDestaques destaques={bannersCarousel} />
      </Suspense>
      <PrimeiraSecaoHomeDesktop>
        <Suspense fallback={<BeneficiosChippuDesktopFallback />}>
          <BeneficiosChippu />
        </Suspense>
        <Suspense fallback={<Skeleton style={{ height: 510 }} />}>
          <Galeria imagens={destaquesDesktop} />
        </Suspense>
        <Suspense fallback={<Skeleton style={{ height: 234 }} />}>
          <AssinaturasRecorrentes style={{ zIndex: 10 }} />
        </Suspense>
      </PrimeiraSecaoHomeDesktop>
      <SegundaSecaoHomeDesktop>
        <Suspense fallback={<Skeleton style={{ height: 809 }} />}>
          <MinhaCarteiraDestaque />
        </Suspense>
      </SegundaSecaoHomeDesktop>
      <UltimaSecaoHomeDesktop>
        <Suspense fallback={<Skeleton style={{ height: 882 }} />}>
          <DestaquesDaSemana />
        </Suspense>
        <Suspense fallback={<Skeleton style={{ height: 510 }} />}>
          <Galeria imagens={bannersPromocionaisDesktop} />
        </Suspense>
        {combos?.length ? (
          <PlanosDisponiveis
            style={{ padding: 0, paddingTop: theme.spacing[5] }}
          />
        ) : null}
        <Suspense fallback={<Skeleton style={{ height: 910 }} />}>
          <ListagemCreditosHomeTemplate />
        </Suspense>
        {/* <Suspense fallback={<MinhaCarteiraDetalhamentoFallback />}>
          <MinhaCarteiraDetalhamento />
        </Suspense> */}
      </UltimaSecaoHomeDesktop>
    </Fragment>
  );
}
